import { FC } from "react";
import "@mobiscroll/react/dist/css/mobiscroll.react.min.css";
import { Datepicker, localeEs, localeEn } from "@mobiscroll/react";

import clsx from "clsx";

interface Props {
  label?: string;
  cornerHint?: string;
  helpText?: string;
  placeholder?: string;
  name?: string;
  onChange?: (date: Date) => void;
  value?: Date | Date[];
  minDate?: Date;
  maxDate?: Date;
  minRange?: number;
  maxRange?: number;
  error?: string;
  touched?: boolean;
  locale?: "es" | "en";
  isRange?: boolean;
  pages?: number | "auto";
  rangeStartLabel?: string;
  rangeEndLabel?: string;
}

const DatePicker: FC<Props> = ({
  label,
  cornerHint,
  helpText,
  placeholder = "dd/mm/aaaa",
  name,
  onChange,
  value,
  minDate,
  maxDate,
  minRange,
  maxRange,
  error,
  touched,
  locale = "es",
  isRange = false,
  pages = "auto",
  rangeStartLabel,
  rangeEndLabel,
}) => {
  return (
    <div>
      <div className="tw-flex tw-justify-between">
        {label && (
          <label
            htmlFor={name}
            className={clsx(
              "tw-block tw-text-sm tw-font-medium ",
              error && touched ? "tw-text-red-500" : "tw-text-gray-700"
            )}
          >
            {label}
          </label>
        )}
        {cornerHint && (
          <span
            className={clsx(
              "tw-text-sm",
              error && touched ? "tw-text-red-500" : "tw-text-gray-500"
            )}
          >
            Optional
          </span>
        )}
      </div>
      <div className="tw-mt-1">
        <Datepicker
          locale={locale === "es" ? localeEs : localeEn}
          select={isRange ? "range" : "date"}          
          responsive={{
            xsmall: {
              pages: 1,
              touchUi: true,
              controls:[isRange ? "calendar" : "date"]
            },
            small: {
              pages: pages,
              touchUi: true,
              controls:[isRange ? "calendar" : "date"]
            },
            medium: {
              touchUi: false,
              pages: pages,
              controls:["calendar"]
            },
          }}
          name={name}
          min={minDate}
          max={maxDate}
          minRange={minRange}
          maxRange={maxRange}
          rangeStartLabel={rangeStartLabel}
          rangeEndLabel={rangeEndLabel}
          defaultValue={value}
          inputComponent="input"
          inputProps={{
            placeholder: placeholder,
            className:
              "tw-shadow-sm focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-block tw-w-full sm:tw-text-sm  tw-rounded-md disabled:tw-bg-gray-100 disabled:tw-cursor-not-allowed tw-border-gray-300",
            type: "text",
          }}
          onChange={(e, inst) => {
            onChange && onChange(e);
          }}
        />
      </div>
      {helpText && (!error || !touched) && (
        <p className="tw-mt-2 tw-text-xs tw-text-gray-500">{helpText}</p>
      )}
      {error && touched && (
        <p className="tw-mt-2 tw-text-xs tw-text-red-500">{error}</p>
      )}
    </div>
  );
};

export default DatePicker;
